export default {
  ARBITRATORS: ' arbitratorApp/',
  GAMERS: 'gamerApp/',
  GLOBAL: 'global/',
}



// WEBPACK FOOTER //
// ./src/app/const/namespace.js